import { createTRPCReact, CreateTRPCReact } from '@trpc/react-query';
import type { AppRouter } from '@good/auth-service';

export const reactTrpc: CreateTRPCReact<AppRouter, unknown, null> = createTRPCReact<AppRouter>();
